import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ModuleHead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        headingId: PropTypes.string,
    };

    render() {
        const content = this.props.content || {};
        const { headingId } = this.props;

        return (
            <div className={styles.moduleHead}>
                <h2 id={headingId} className={styles.title}>
                    {content.zhText}
                </h2>
                {content.enText ? <div className={styles.subTitle}>{content.enText}</div> : null}
                {content.moreUrl ? (
                    <a href={content.moreUrl} className={styles.more}>
                        更多
                    </a>
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(ModuleHead);
